module.exports = __webpack_public_path__ + "static/media/logo.06bce7c1.png";